/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import parse, { domToReact } from 'html-react-parser';
import InstagramEmbed from 'react-instagram-embed';
// import ModalImage from 'react-modal-image';
import { isShortCode } from './ShortCodes';
import Button from '../common/button/Button';
import PlayBuzz from '../common/Playbuzz/PlayBuzz';
import Tweet from '../common/Tweet/Tweet';
import FreeStreamingModal from '../components/freeStreaming/containers/freeStreamingModalContainer';
import MusicItemShortcode from '../components/musics/containers/MusicItemShortcodeContainer';
import Youtube from '../common/Youtube/Youtube';
import {
    extractTweetId,
    extractYoutubeVideoId,
    findYoutubeIframe,
    getInstagramEmbedProps,
    stripQueryString,
} from './embedHelpers';

/**
 * Note: There is a different transformHtml file for the mobile app content! (mobileAppTransformHTML.js)
 */

/**
 * This functions takes html content and transforms it to be compatible with react
 * This means that everything will be transformed to react components, especially internal links, but also twitter and instagram embeded
 * This function is ment to be used with the old Antena 1 database content but should work with all type of html
 *
 * Note: this function will also replace the short codes with the corresponding component. (in the form of <p>[short-code]</p>)
 *
 * The transformHTMLExcerpt basically removes everything that is not text and is meant to be used for the news excerpts.
 */
export function transformHTML(content) {
    if (!content) {
        return '';
    }

    // const numImageInContent = 0;
    const options = {
        replace: (domNode) => {
            // console.log('node.type', node.type);
            // console.log('node.name', node.name);
            // console.log("node.att", node.attribs)
            // console.log('node.att', node.data);

            // if (domNode.type === 'tag' && (domNode.name === 'p' || domNode.name === 'figure') && domNode.children && domNode.children[0] && domNode.children[0].name === 'img') {
            //     // replace images with a modal that can be clicked to show a bigger version of the image...
            //     // Note: The old tinyMCE editor put images into p tags, the new CKEditor puts them into figure tags
            //     const imageAttribs = domNode.children[0].attribs;
            //     const imageSrc = imageAttribs.src;
            //     const imageAlt = imageAttribs.alt;
            //     const imageTitle = imageAttribs.title;
            //     const smallImageSrc = imageSrc;
            //     let mediumImageSrc = imageSrc;
            //     let largeImageSrc = imageSrc;

            //     if (!imageSrc) {
            //         // if no src is given, remove this node
            //         return undefined;
            //     }

            //     // check if it is an image of the new "type", if so, use the medium and large images as well
            //     if (imageSrc.indexOf('/small/')) {
            //         mediumImageSrc = imageSrc.replace('/small/', '/medium/');

            //         largeImageSrc = imageSrc.replace('/small/', '/large/');
            //     }

            //     numImageInContent += 1;

            //     return (
            //         <React.Fragment>
            //             <ModalImage
            //                 className="imageInContent"
            //                 small={smallImageSrc}
            //                 medium={mediumImageSrc}
            //                 large={largeImageSrc}
            //                 alt={imageTitle || imageAlt || `${imageInContentDefaultAlt} #${numImageInContent}`}
            //                 hideDownload
            //             />
            //             <div className="imageInContentClickHint">Toque para aumentar</div>
            //         </React.Fragment>
            //     );
            // }

            if (domNode.type === 'tag' && domNode.name === 'a') {
                // change internal links to be Button Links
                // normal external links should stay the same...
                // if internal, return a Button. It is internal if it has a linkText attribute, that was added via the API

                if (domNode.attribs.linktext) {
                    return (
                        <Button key={domNode.attribs.linktext} className="TextLink" title={domNode.attribs.title} to={domNode.attribs.href}>
                            {domNode.attribs.linktext}
                        </Button>
                    );
                }

                // else, do nothing (probably)
                return undefined;
            }

            if (domNode.type === 'tag' && domNode.name === 'blockquote' && domNode.attribs && domNode.attribs.class === 'twitter-tweet') {
                // transform embeded twitter posts
                // Note: See below for oembed twitter posts (via CKEditor)
                let url;

                if (domNode.children && domNode.children[3] && domNode.children[3].attribs.href) {
                    // normal embed (via tinyMCE)
                    url = domNode.children[3].attribs.href;
                } else if (domNode.children && domNode.children[1] && domNode.children[1].children &&
                    domNode.children[1].children[1] && domNode.children[1].children[1].attribs.href) {
                    // normal embed (via CKEditor)
                    url = domNode.children[1].children[1].attribs.href;
                } else {
                    // tweet url not found
                    return undefined;
                }

                const tweetId = extractTweetId(url);

                if (!tweetId) {
                    return undefined;
                }

                return <Tweet key={url} tweetId={tweetId} />;
            }

            if (domNode.type === 'tag' && domNode.name === 'blockquote' && domNode.attribs && domNode.attribs.class === 'instagram-media') {
                // transform embeded instagram posts
                // Note: See below for oembeded Instagram posts (via CKEditor)
                if (domNode.attribs['data-instgrm-permalink']) {
                    const permaLink = stripQueryString(domNode.attribs['data-instgrm-permalink']);

                    if (!permaLink) {
                        return undefined;
                    }

                    const instagramEmbedProps = getInstagramEmbedProps(permaLink);

                    if (!instagramEmbedProps) {
                        return undefined;
                    }

                    return (
                        <InstagramEmbed
                            key={permaLink}
                            url={instagramEmbedProps.url}
                            hideCaption={instagramEmbedProps.hideCaption}
                            clientAccessToken={instagramEmbedProps.clientAccessToken}
                        />
                    );
                }

                return undefined;
            }

            if (domNode.type === 'tag' && domNode.name === 'figure' && domNode.attribs && domNode.attribs.class === 'media') {
                // CKEditor media embed (oembed)
                // Note: all media elements are figures with a media class that have an oembed element as only child with a (oembed) url property
                const oembedUrl = domNode.children && domNode.children[0] && domNode.children[0].attribs && domNode.children[0].attribs.url;

                if (!oembedUrl) {
                    // no oembed url found, remove the element
                    return undefined;
                }

                if (oembedUrl.includes('twitter.com')) {
                    // It is a tweet (probably)
                    const tweetId = extractTweetId(oembedUrl);

                    if (!tweetId) {
                        return undefined;
                    }

                    return <Tweet key={oembedUrl} tweetId={tweetId} />;
                }

                if (oembedUrl.includes('instagram.com')) {
                    // It is a Instagram post (probably)

                    const instagramEmbedProps = getInstagramEmbedProps(oembedUrl);

                    if (!instagramEmbedProps) {
                        return undefined;
                    }

                    return (
                        <InstagramEmbed
                            key={oembedUrl}
                            url={instagramEmbedProps.url}
                            hideCaption={instagramEmbedProps.hideCaption}
                            clientAccessToken={instagramEmbedProps.clientAccessToken}
                        />
                    );
                }

                if (oembedUrl.includes('youtube.com') || oembedUrl.includes('youtu.be')) {
                    // It is a youtube video (probably)

                    const videoId = extractYoutubeVideoId(oembedUrl);

                    if (!videoId) {
                        // Keep SSR resilient when malformed or unexpected YouTube URLs are stored in content.
                        return undefined;
                    }

                    // put a wrapping div around so that the iframe can be responsive
                    return (
                        <div className="youtube-iframe-wrapper">
                            <Youtube
                                videoId={videoId}
                                allowFullScreen={false}
                            />
                        </div>
                    );
                }

                if (oembedUrl.includes('vimeo.com')) {
                    // It is a vimeo video (probably)
                    const iframeUrl = oembedUrl.replace('vimeo.com', 'player.vimeo.com/video');

                    // put a wrapping div around so that the iframe can be responsive
                    return (
                        <div className="youtube-iframe-wrapper">
                            <iframe
                                title="Vimeo Embedded Video"
                                src={iframeUrl}
                                height={315}
                                width={560}
                                frameBorder={0}
                                allowFullScreen={false}
                            />
                        </div>
                    );
                }

                return undefined;
            }

            if (domNode.type === 'tag' && domNode.name === 'div' && domNode.attribs && domNode.attribs.class === 'playbuzz') {
                // transform embeded playbuzz code (must be implemented via source code on admin, only the html (div) part of the embed code)
                if (domNode.attribs['data-id']) {
                    const id = domNode.attribs['data-id'];

                    return <PlayBuzz key={`playbuzz-${id}`} id={id} />;
                }

                return undefined;
            }

            // check for embedded youtube videos (from old tinyMCE editor)
            // find p tags that have an iframe as child
            // Note: This does not find every embedded youtube videos. There are quite a lot of news that are wrapped within one single p tag.
            // Those cases cannot be treated here. But I cleaned all news until the beginning of 2020. I assume that it is ok for now
            // Note2: I assume that those news happen when the complete text was copy pasted and inserted into the admin...
            if (domNode.type === 'tag' && domNode.name === 'p' && domNode.children && domNode.children[0]) {
                const youtubeIframe = findYoutubeIframe(domNode.children[0]);

                if (youtubeIframe) {
                    // put a wrapping div around so that the iframe can be responsive
                    const attribs = youtubeIframe.attribs;

                    const videoId = extractYoutubeVideoId(attribs && attribs.src);

                    if (!videoId) {
                        // Keep original HTML rendering when URL does not match the expected YouTube patterns.
                        return domToReact(domNode, options);
                    }

                    return (
                        <div className="youtube-iframe-wrapper">
                            <Youtube
                                videoId={videoId}
                                allowFullScreen={false}
                            />
                        </div>
                    );
                }

                // Note: not returning anything so that the following code can check if domnode is a shortcode
            }

            // check for shortcodes (<p>[short-code]</p>)
            if (domNode.type === 'tag' && domNode.name === 'p') {
                const child = domNode.children && domNode.children[0];

                if (child && child.type === 'text' && child.data && child.data.length > 3) {
                    // avoid checking impossible nodes by length > 3
                    // replace the antena 1 shortcode with corresponding component (currently: [free-streaming] and [music-item artistSlug=artist-slug musicSlug=music-slug download(optional)])
                    // the shortcode must be like this: <p>[short-code]</p> (this should happen automatically when inserting [short-code] in the admin content area)
                    // note: if an option is present in the shortcode it will be treated as boolean true
                    const shortcode = isShortCode(child.data);

                    if (!shortcode) {
                        return (
                            domToReact(domNode, options)
                        );
                    }

                    if (shortcode.name === 'free-streaming') {
                        return <FreeStreamingModal key="free-streaming" />;
                    }

                    if (shortcode.name === 'music-item') {
                        const { artistSlug, musicSlug, download } = shortcode.options;

                        if (!artistSlug || !musicSlug) {
                            // eslint-disable-next-line no-console
                            console.log(`missing parameter for shortcode ${shortcode.name}. artistSlug and musicSlug are mandatory.`);

                            return <React.Fragment />; // removing the shortcode in this case
                        }

                        return <MusicItemShortcode key={`${artistSlug}+${musicSlug}`} artistSlug={artistSlug} musicSlug={musicSlug} showDownloadButton={download} />;
                    }

                    return <React.Fragment />; // remove unknown shortcodes
                }

                return domToReact(domNode, options);
            }

            return undefined;
        },
    };

    return parse(content, options);
}

export function transformHTMLExcerpt(content) {
    // Return reduced content for excerpts (remove links)
    // The rest was already filtered by the shortenNewsContent function in the helper
    if (!content) {
        return '';
    }

    const options = {
        replace: (domNode) => {
            if (domNode.type === 'tag' && domNode.name === 'a') {
                // return only the link text
                if (domNode.attribs.linktext) {
                    return (
                        <React.Fragment>
                            {domNode.attribs.linktext}
                        </React.Fragment>
                    );
                }

                if (domNode.children && domNode.children[0] && domNode.children[0].data) {
                    // return only the content of the link
                    return (
                        <React.Fragment>
                            {domNode.children[0].data}
                        </React.Fragment>
                    );
                }

                // return some default text (while figuring out, when this happens)
                return <React.Fragment>LINK</React.Fragment>;
            }

            return undefined;
        },
    };

    return parse(content, options);
}

/**
 *  * Converts a string containing HTML tags into renderable HTML content.
 * If the `limitText` parameter is true, the content is truncated to a specified character limit
 * and adds "..." at the end if it exceeds the limit.
 * @param {string} content
 * @param {boolean} limitText
 * @param {number} charLimit
 * @returns {JSX.Element|string}
 */
const renderHTMLContent = (content, limitText = false, charLimit = 200) => {
    if (!content) return '';

    if (limitText && content.length > charLimit) {
        const truncatedContent = `${content.slice(0, charLimit)}...`;

        return (
            <div>
                {parse(truncatedContent)}
            </div>
        );
    }

    return (
        <div>
            {parse(content)}
        </div>
    );
};

export default renderHTMLContent;
